import { deepFreeze } from '@shared/lib/deepFreeze';

export const DATETIME_STEP_LABELS = deepFreeze({
  date: 'Enter a date',
  time: 'Enter a time',
});

export const INPUT_MODE_PICKER = 'picker';
export const INPUT_MODE_TEXT = 'text';
